import { ArrowRight } from "lucide-react";

export default function ReadyToHire() {
  return (
    <section
      className="w-full py-16 md:py-20 lg:py-16"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        
        {/* Simple Centered CTA */}
        <div 
          className="rounded-2xl text-center py-10 md:py-12 lg:py-20 px-6 md:px-8"
          style={{ 
            backgroundColor: "#00356B",
            border: "1px solid rgba(255, 255, 255, 0.28)",
            boxShadow: "0 24px 60px rgba(14, 165, 233, 0.28)"
          }}
        >

          {/* Heading */}
          <h3
            className="text-4xl md:text-5xl font-semibold mb-3"
            style={{ 
              fontFamily: 'Outfit, sans-serif',
              color: '#ffffff'
            }}
          >
            Ready to Hire Top IT
              Technology Talent?
          </h3>

          {/* Description */}
          <p
            className="text-md max-w-2xl mx-auto mb-6 text-center"
            style={{ 
              fontFamily: '"Open Sans", sans-serif',
              lineHeight: '160%',
              color: '#ffffff',
              textAlign: 'center'
            }}
          >
            Partner with Kapil Tech to access pre-vetted SAP consultants, IT professionals, 
            and technology experts who can help your business grow with confidence.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-3">
            <a
              href="#Request-Talent"
              className="inline-flex items-center gap-2 px-6 py-4 rounded-lg transition-all duration-300 group"
              style={{ 
                backgroundColor: '#ffffff',
                transform: 'translateY(0)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <span
                className="text-sm font-semibold"
                style={{ 
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#081120'
                }}
              >
                Request Talent
              </span>
              <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" style={{ color: '#081120' }} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
